module.exports = __webpack_public_path__ + "static/media/check.1692cbb0.svg";